module.controller('signupCreateCtrl', ['cardOrderService', '$state', 'localStorageService', function(cardOrderService, $state, localStorageService) {

  var vm = this;

  vm.checkCardPurpose = checkCardPurpose;
  vm.cards = cardOrderService.getCards();
  vm.nextStep = nextStep;
  vm.checkPressedKey = checkPressedKey;

  init();


  function init() {
    var names = $state.params.CardName;
    var firstName;
    var lastName;

    if ( names !== undefined ) {
      firstName = names.split(' ').slice(0, 1).join(' ');
      lastName = names.split(' ').slice(1).join(' ');
    }


    if (vm.cards.length === 0) {
      cardOrderService.createCard(firstName, lastName);
    }
    vm.currentCard = cardOrderService.getCurrentCard();
  }

  function checkCardPurpose(CardPurpose, currentCard) {
    vm.currentCard.CardPurpose = CardPurpose;
    defineATMInternationalAccess(vm.currentCard);
  }

  function defineATMInternationalAccess(card) {
    switch(card.CardPurpose) {
      case 'personal':
        card.ATMInternationalAccess = true;
        break;
      case 'allowance':
      case 'household':
        card.ATMInternationalAccess = false;
        break;
    }
  }

  function nextStep() {
    localStorageService.set('cardOrderCurrentCard', vm.currentCard);
    $state.go('signup.customize');
  }

  function checkPressedKey(event){
    if (event.keyCode === 13) {
      nextStep();
    }
  }

}]);
